/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairRawBoardingPassV2Request } from '../../models/finnair-raw-boarding-pass-v-2-request';
import { FinnairRawBoardingPassV2ResponseItem } from '../../models/finnair-raw-boarding-pass-v-2-response-item';

export interface GetRawBoardingPassPrivate$Params {
  orderId: string;
  lastName: string;
  firstName?: string;
      body: FinnairRawBoardingPassV2Request
}

export function getRawBoardingPassPrivate(http: HttpClient, rootUrl: string, params: GetRawBoardingPassPrivate$Params, context?: HttpContext): Observable<DapiHttpResponse<Array<FinnairRawBoardingPassV2ResponseItem>>> {
  const rb = new DapiRequestBuilder(rootUrl, getRawBoardingPassPrivate.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('lastName', params.lastName, {});
    rb.query('firstName', params.firstName, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<Array<FinnairRawBoardingPassV2ResponseItem>>;
    }),
    catchErrorAsJson()
  );
}

getRawBoardingPassPrivate.PATH = '/api/v2/checkin/private/{orderId}/raw-boarding-pass';
